import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchPreferences, updatePreferencesApi, type UserPreferences } from '../services/api/preferences';

export function usePreferences(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['preferences'],
    enabled: options.enabled ?? true,
    queryFn: fetchPreferences,
    staleTime: 5 * 60 * 1000, // 5 minutes
    select: (res) => res.data,
  });
}

export function useUpdatePreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePreferencesApi,
    onMutate: async (newPrefs) => {
      await queryClient.cancelQueries({ queryKey: ['preferences'] });
      const previous = queryClient.getQueryData<{ data: UserPreferences }>(['preferences']);
      queryClient.setQueryData<{ data: UserPreferences }>(['preferences'], (old) => ({
        data: { ...(old?.data || {}), ...newPrefs },
      }));
      return { previous };
    },
    onError: (_err, _newPrefs, context) => {
      if (context?.previous) {
        queryClient.setQueryData(['preferences'], context.previous);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['preferences'] });
    },
  });
}
